import { Ability } from '@casl/ability';

export const ability = new Ability();
export const abilityPlugin = (store) => store.subscribe((mutation) => {

    if (mutation.type === 'SET_PERMISSIONS_USER') {
        let rights = [];
        if (mutation.payload.length > 0) {
            rights = mutation.payload.map( right => {
                return {
                    action: right.action,
                    subject: right.subject
                }
            })
        }
        ability.update(rights);
    }
});